import { mapGetters } from 'vuex'

import Configuration from '@/agilis/util/Configuration'
import TabsComponent from '@/agilis/components/Tabs/Tabs.vue'
import TreeEditor from '@/agilis/components/TreeEditor/TreeEditor.vue'

export default {
  name: 'documentTabs',

  components: {
    TabsComponent,
    TreeEditor
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId'
    }),

    tabs () {
      return Configuration.document.getAvailableDocuments(this.applicationId, this.workspaceId)
    }
  },

  methods: {
    getDocument (documentId) {
      return Configuration.document.getDocument(this.applicationId, documentId)
    },

    getDocumentName (documentId) {
      const document = this.getDocument(documentId)
      return document.name ? this.$t(document.name) : document.id
    },

    getSchema (documentId) {
      const document = this.getDocument(documentId)
      return Configuration.document.getDocumentSchema(this.applicationId, document)
    },

    getComponentId (documentId) {
      return this.getDocument(documentId).componentId
    }
  }
}
